import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlimentoModel, categoriasAlimento, superAlimentos, unidadesAlimentos } from 'src/app/models/alimento.model';
import { DocumentsService } from 'src/app/services/document.service';
import { UploadService } from 'src/app/services/upload.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { Dimensions, ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-alimentos-d',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    FormsModule, 
    ImageCropperModule
  ],
  templateUrl: './alimentos-d.component.html',
  styleUrl: './alimentos-d.component.css'
})
export class AlimentosDComponent implements OnInit {
  @Input({required: true}) userInfo: any;

  formAlimento: FormGroup;
  listaAlimentos: any = [];
  categoriasAlimentos: any = categoriasAlimento;
  superAlimentos: any = superAlimentos;
  unidadesAlimentos: any = unidadesAlimentos;
  submitFormAlimento: boolean = false;
  dataTableAlimentos: any;
  editarAlimento: any = false;
  pattern: string = 'alimento';
  env: any = environment

  filtroCategoria = ''
  filtroPropietario = 'todos'

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private uploadService: UploadService,
              private utilsService: UtilsService) {
    this.formAlimento = this.fb.group
    ({
        nombre: ['', [Validators.required]],
        categoria: ['', [Validators.required]],
        super: ['', [Validators.required]],
        marca: [''],
        porcion: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        unidad: ['', [Validators.required]],
        calorias:  ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        carbohidratos: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        azucar: ['', [Validators.pattern("^[0-9.]*$")]],
        fibra: ['', [Validators.pattern("^[0-9.]*$")]],
        proteinas: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        grasaTotal: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        grasaSaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaMonoinsaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaPoliinsaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaTrans: ['', [Validators.pattern("^[0-9.]*$")]],
        colesterol: ['', [Validators.pattern("^[0-9.]*$")]],
        informacion: [''],
    })
  }
  ngOnInit(): void {
    this.getAlimentos();
  }

  @Output() messageEvent = new EventEmitter<string>();
  sendAlimentoSelected(alimento) {
    this.messageEvent.emit(alimento);
  }
  
  getAlimentos() 
  {
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtroCategoria != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtroCategoria
        }
      });
    }
    let should: any = []
    switch (this.filtroPropietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
        {
          "bool": { should }
        }
    )
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };

    setTimeout(() => {
      this.documentService.searchDocument(this.env.businessId, this.pattern, query).subscribe({
        next: (data: any) => {
          console.log(data)
          if(this.dataTableAlimentos) {
            this.dataTableAlimentos.destroy();
            this.dataTableAlimentos = null; // Eliminar la referencia
          }
          this.listaAlimentos = [];

          this.listaAlimentos = data;
          this.inicializarDataTableAlimentos();
        },
        error: (error: any) => {
          console.error(error);
          this.inicializarDataTableAlimentos();
        }
      });
    }, 1000);
  }

  inicializarDataTableAlimentos()
  {
    if (this.dataTableAlimentos) {
      this.dataTableAlimentos.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableAlimentos = $('#dataTable-listaAlimentos').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  /**************************************************/
  /************ AGREGAR/EDITAR ALIMENTO *************/
  modalAlimento()
  {
    $('#modal-alimento').modal({backdrop: 'static', keyboard: false})
    $("#modal-alimento").modal('show');
  }
  modalEditarAlimento(alimento)
  {
    this.editarAlimento = alimento;
    //if(alimento.imagen) this.previewUrl = alimento.imagen.url
    if(alimento.imagen) this.previewUrlProducto = alimento.imagen.url;
    if(alimento.imagenEtiqueta) this.previewUrlEtiqueta = alimento.imagenEtiqueta.url;

    this.formAlimento.setValue({
      nombre: alimento.nombre,
      categoria: alimento.categoria,
      super: alimento.super,
      marca: alimento.marca,
      porcion: alimento.porcion,
      unidad: alimento.unidad,
      calorias:  alimento.calorias,
      carbohidratos: alimento.carbohidratos,
      azucar: alimento.azucar,
      fibra: alimento.fibra,
      proteinas: alimento.proteinas,
      grasaTotal: alimento.grasaTotal,
      grasaSaturada: alimento.grasaSaturada, 
      grasaMonoinsaturada: alimento.grasaMonoinsaturada,
      grasaPoliinsaturada: alimento.grasaPoliinsaturada,
      grasaTrans: alimento.grasaTrans,
      colesterol: alimento.colesterol,
      informacion: alimento.informacion,
    })
    this.enableOrDisableInputs(false)
    this.modalAlimento();
  }
  createOrUpdateSuplementoFn() {
    this.submitFormAlimento = true;
    if(this.formAlimento.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    let alimentoDocModel: AlimentoModel = {
      nombre: this.formAlimento.get('nombre').value,
      categoria: this.formAlimento.get('categoria').value,
      super: this.formAlimento.get('super').value,
      marca: this.formAlimento.get('marca').value ? this.formAlimento.get('marca').value : '',
      porcion: this.formAlimento.get('porcion').value,
      unidad: this.formAlimento.get('unidad').value,
      calorias: this.formAlimento.get('calorias').value,
      carbohidratos: this.formAlimento.get('carbohidratos').value,
      azucar: this.formAlimento.get('azucar').value != null ? this.formAlimento.get('azucar').value : null,
      fibra: this.formAlimento.get('fibra').value != null ? this.formAlimento.get('fibra').value : null,
      proteinas: this.formAlimento.get('proteinas').value,
      grasaTotal: this.formAlimento.get('grasaTotal').value,
      grasaSaturada: this.formAlimento.get('grasaSaturada').value != null ? this.formAlimento.get('grasaSaturada').value : null,
      grasaMonoinsaturada: this.formAlimento.get('grasaMonoinsaturada').value != null ? this.formAlimento.get('grasaMonoinsaturada').value : null,
      grasaPoliinsaturada: this.formAlimento.get('grasaPoliinsaturada').value != null ? this.formAlimento.get('grasaPoliinsaturada').value : null,
      grasaTrans: this.formAlimento.get('grasaTrans').value != null ? this.formAlimento.get('grasaTrans').value : null,
      colesterol: this.formAlimento.get('colesterol').value != null ? this.formAlimento.get('colesterol').value : null,
      informacion: this.formAlimento.get('informacion').value,
      propietario: this.userInfo.documentContainerId,
      // imagen: null,
      activo: true,
      empresaId: this.userInfo.empresaId
    };
    // if(this.croppedImage != null && this.rawFile != null) {
    //   let croppedImage = this.croppedImage.replace(/^data:.+;base64,/, '')
    //   this.uploadService.uploadImage(environment.businessId, this.utilsService.create_UUID(), this.rawFile.name, croppedImage, this.rawFile.type).subscribe({
    //     next: (fileData: any) => {
    //       alimentoDocModel.imagen = { url: fileData.fileName, nombre: this.rawFile.name};
    //
    //       if(this.editarAlimento) this.updateAlimentoFn(alimentoDocModel, this.editarAlimento.documentId);
    //       if(!this.editarAlimento) this.createAlimentoFn(alimentoDocModel);
    //     },
    //     error: (error) => {
    //       console.error(error)
    //     }
    //   })
    // }
    // else {
    //   if(this.previewUrl == null) alimentoDocModel.imagen = null;
    //   if(this.editarAlimento) this.updateAlimentoFn(alimentoDocModel, this.editarAlimento.documentId);
    //   if(!this.editarAlimento) this.createAlimentoFn(alimentoDocModel);
    // }

    if(this.croppedImageProducto!='' && this.rawFileProducto!=null) alimentoDocModel.imagen = { nombre: this.rawFileProducto.name, url: this.rawFileProducto.url };
    if(this.croppedImageEtiqueta!='' && this.rawFileEtiqueta!=null) alimentoDocModel.imagenEtiqueta =  { nombre:this.rawFileEtiqueta.name, url: this.rawFileEtiqueta.url };

    if(this.croppedImageProducto=='' && this.rawFileProducto==null && this.previewUrlProducto==null) alimentoDocModel.imagen = null;
    if(this.croppedImageEtiqueta=='' && this.rawFileEtiqueta==null && this.previewUrlEtiqueta==null) alimentoDocModel.imagenEtiqueta = null;

    if(this.editarAlimento) this.updateAlimentoFn(alimentoDocModel, this.editarAlimento.documentId);
    if(!this.editarAlimento) this.createAlimentoFn(alimentoDocModel);
  }
  createAlimentoFn(alimentoDocModel) {
    let businessId = this.env.businessId;
    // let event: any = {}

    this.documentService.createDocumentInContainer(
      businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      null,
      this.pattern,
      null,
      alimentoDocModel,
    ).subscribe({
      next: (data) => {
          // debugger
          console.log(data);
          this.submitFormAlimento = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Alimento guardado con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          $("#modal-alimento").modal('hide');
          this.getAlimentos();
          this.inicializarFormAlimento();
        },
      error: (error) => {
        console.error(error);
      },
    });
  }
  updateAlimentoFn(alimentoDocModel: AlimentoModel, documentId) {
    let title = ''
    if(alimentoDocModel.activo) title = "Alimento actualizado con éxito";
    if(!alimentoDocModel.activo) title = "Alimento eliminado con éxito";

    this.documentService
      .updateDocumentInContainer(
        this.env.businessId,
        this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
        documentId,
        this.pattern,
        null,
        alimentoDocModel
      )
      .subscribe({
        next: (data) => {
          console.log(data);
          this.submitFormAlimento = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: title,
            showConfirmButton: false,
            timer: 1500
          });
          if(alimentoDocModel.activo) $("#modal-alimento").modal('hide');
          this.getAlimentos();
          this.inicializarFormAlimento();
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  deleteAlimentoFn(alimentoDocModel) {
    Swal.fire({
      title: 'Eliminar alimento',
      html: '¿Seguro que desea eliminar el alimento: <b>"'+alimentoDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        alimentoDocModel.activo = false;
        this.updateAlimentoFn(alimentoDocModel, alimentoDocModel.documentId)
      }
    })
  }

  inicializarFormAlimento()
  {
    this.editarAlimento = false;
    //this.errorFileType(false);
    this.deleteImage('Producto');
    this.deleteImage('Etiqueta');

    this.enableOrDisableInputs(true);
    this.formAlimento.setValue({
      nombre: '',
      categoria: '',
      super: '',
      marca: '',
      porcion: '',
      unidad: '',
      calorias:  '',
      carbohidratos: '',
      azucar: '',
      fibra: '',
      proteinas: '',
      grasaTotal: '',
      grasaSaturada: '', 
      grasaMonoinsaturada: '',
      grasaPoliinsaturada: '',
      grasaTrans: '',
      colesterol: '',
      informacion: '',
    })
  }
  enableOrDisableInputs(enable)
  {
    const controles = [
      'porcion',
      'unidad',
      'calorias',
      'carbohidratos',
      'azucar',
      'fibra',
      'proteinas',
      'grasaTotal',
      'grasaSaturada',
      'grasaMonoinsaturada',
      'grasaPoliinsaturada',
      'grasaTrans',
      'colesterol'
    ];
    controles.forEach(control => {
      const abstractControl = this.formAlimento.get(control);
      if (abstractControl) {
        if(!enable) abstractControl.disable();
        if(enable) abstractControl.enable();
      }
    });
  }

  /**************** IMAGEN PLATILLO *****************/
  // Propiedades para Image Cropper
  // imageChangedEvent: any = '';
  // croppedImage: any = '';
  // bolCroppedImg: boolean = false;
  // // Información del archivo original
  // selectedFile: File | null = null;
  // rawFile: any;
  // previewUrl: string | ArrayBuffer | null = null;
  // fileChangeEvent(event: any): void {
  //   const input = event.target as HTMLInputElement;
  //
  //   if (input.files && input.files.length > 0) {
  //     this.selectedFile = input.files[0];
  //
  //     // Configurar el evento para el cropper
  //     this.imageChangedEvent = event;
  //     this.bolCroppedImg = true;
  //
  //     // Almacenar detalles del archivo
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       this.rawFile = {
  //         file: reader.result,
  //         type: this.selectedFile?.type,
  //         name: this.selectedFile?.name
  //       };
  //       console.log('Raw File:', this.rawFile);
  //     };
  //     reader.readAsBinaryString(this.selectedFile);
  //   }
  // }
  // imageCropped(event: ImageCroppedEvent) {
  //   this.croppedImage = event.base64; // Imagen recortada en base64
  //   // console.log('Cropped Image:', this.croppedImage);
  // }
  // imageLoaded() {
  //   console.log('Image loaded');
  // }
  // cropperReady(sourceImageDimensions: Dimensions) {
  //   console.log('Cropper ready', sourceImageDimensions);
  // }
  // loadImageFailed() {
  //   console.error('Failed to load image');
  //   this.errorFileType(true);
  // }
  // deleteImage() {
  //   this.errorFileType(false);
  // }
  // errorFileType(alert: boolean) {
  //   this.croppedImage = '';
  //   this.imageChangedEvent = '';
  //   this.bolCroppedImg = false;
  //   this.selectedFile = null;
  //   this.previewUrl = null;
  //   this.rawFile = null;
  //   if (alert) {
  //     console.error('Invalid file type. Please select an image.');
  //   }
  // }

  get formAlimentoControl()
  {
    return this.formAlimento.controls;
  }
  /******************* IMÁGENES ********************/
      // Propiedades para Image Cropper
  imageChangedEventProducto: any = '';
  imageChangedEventEtiqueta: any = '';
  croppedImageProducto: string = '';
  croppedImageEtiqueta: string = '';
  bolCroppedImgProducto: boolean = false;
  bolCroppedImgEtiqueta: boolean = false;
  rawFileProducto: any;
  rawFileEtiqueta: any;

  // Previsualización de las imágenes
  previewUrlProducto: string | null = null;
  previewUrlEtiqueta: string | null = null;

  fileChangeEvent(event: any, tipo: 'Producto' | 'Etiqueta'): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (tipo === 'Producto') {
          this.imageChangedEventProducto = event;
          this.bolCroppedImgProducto = true;
          this.rawFileProducto = {
            file: reader.result,
            type: file?.type,
            name: file?.name
          };
        } else {
          this.imageChangedEventEtiqueta = event;
          this.bolCroppedImgEtiqueta = true;
          this.rawFileEtiqueta = {
            file: reader.result,
            type: file?.type,
            name: file?.name
          };
        }
      };
      reader.readAsBinaryString(file);
    }
  }

  imageCropped(event: ImageCroppedEvent, tipo: 'Producto' | 'Etiqueta') {
    console.log("imageCropped()", event.base64)
    if (tipo === 'Producto') {
      this.croppedImageProducto = event.base64 || '';
      // this.previewUrlProducto = this.croppedImageProducto;
    } else {
      this.croppedImageEtiqueta = event.base64 || '';
      // this.previewUrlEtiqueta = this.croppedImageEtiqueta;
    }

    let croppedImage = event.base64.replace(/^data:.+;base64,/, '');
    let name = tipo === 'Producto' ? this.rawFileProducto.name : this.rawFileEtiqueta.name;
    let type = tipo === 'Producto' ? this.rawFileProducto.type : this.rawFileEtiqueta.type;
    this.uploadService.uploadImage(this.env.businessId, this.utilsService.create_UUID(), name, croppedImage, type).subscribe({
      next: (fileData: any) => {
        if (tipo === 'Producto') {
          this.rawFileProducto.url = fileData.fileName;
        } else {
          this.rawFileEtiqueta.url = fileData.fileName;
        }
      },
      error: (error) => {
        console.error(error)
      }
    })
  }

  imageLoaded(tipo: 'Producto' | 'Etiqueta') {
    console.log(`Image loaded for ${tipo}`);
  }

  cropperReady(event: any, tipo: 'Producto' | 'Etiqueta') {
    console.log(`Cropper ready for ${tipo}`, event);
  }

  loadImageFailed(tipo: 'Producto' | 'Etiqueta') {
    console.error(`Failed to load image for ${tipo}`);
    this.deleteImage(tipo);
  }

  deleteImage(tipo: 'Producto' | 'Etiqueta') {
    if (tipo === 'Producto') {
      this.imageChangedEventProducto = '';
      this.croppedImageProducto = '';
      this.bolCroppedImgProducto = false;
      this.previewUrlProducto = null;
      this.rawFileProducto = null;
    } else {
      this.imageChangedEventEtiqueta = '';
      this.croppedImageEtiqueta = '';
      this.bolCroppedImgEtiqueta = false;
      this.previewUrlEtiqueta = null;
      this.rawFileEtiqueta = null;
    }
  }
}

